import React, { useState } from "react";
import { FormProviderBuyer } from "@/component/shared/termsheetForm/FormContext";
import BuyerEligibilityForm from "@/component/shared/termsheetForm/BuyerEligibility";
import Personaldetails from "@/component/shared/termsheetForm/Personaldetails";
import IMAGES from "@/public/assets/img";
import Image from "next/image";

const BuyerCredit = ({buyerCredit}) => {
  const [showNextStep, setShowNextStep] = useState(false);
  const showSteps = () => {
    setShowNextStep(true);
  };
  const showFirstStep = () => {
    setShowNextStep(false);
  };

  return (
    <section className="relative bg-no-repeat sm:bg-center bg-cover bg-bottom">
    <Image
      src={IMAGES.termsheet.BackgroundBanner}
      alt="Background Banner"
      fill
      priority={true}
      className="object-cover object-bottom -z-10"
    />
      <div className="container xm:px-2 px-3 max-w-[1100px] py-[100px] sm:py-20">
        <h2 className="text-textxl text-baseBlack font-medium text-center sm:text-lg">{buyerCredit.sectionTitle}</h2>
        <h3 className="text-heading5 sm:text-textxl text-baseBlack font-medium text-center">{buyerCredit.mainHeading}</h3>
        <h3 className="text-heading5 sm:text-textxl leading-10 text-baseBlack font-medium text-center">{buyerCredit.mainSubHeading}</h3>
        <div className="flex flex-wrap items-center pt-12 sm:flex-col">
          <div className="w-1/2 sm:w-full md:pb-5 sm:pb-6">
            <div className="relative w-full max-w-md">
              <Image
                src={IMAGES.termsheet.ManTerms}
                width={336}
                height={327}
                alt="Man Image"
                priority={true}
                className="sm:h-[260px] sm:w-[230px]"
              />
              <div className="absolute right-[-24px] bottom-[-33px] sm:right-[-20px] w-[224px]  sm:bottom-[-27px]">
                <Image
                  src={IMAGES.termsheet.RiskMeter}
                  width={224}
                  height={250}
                  alt="Risk Meter"
                  className="sm:h-[190px] sm:w-[170px]"
                  priority={true}
                />
              </div>
            </div>
            <div className="flex gap-4 sm:gap-1 justify-center mt-4 w-3/4 sm:w-full">
              {buyerCredit.benefits.map((item, index) => (
                <div key={index} className="w-1/4 sm:w-1/3">
                  <Image
                    src={item.icon}
                    alt={item.text}
                    width={50}
                    height={50}
                    className="mb-2"
                    priority={true}
                  />
                  <p className="text-gray-700 text-base font-medium">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="w-1/2 sm:w-full">
            <FormProviderBuyer>
              {!showNextStep ? (
                <BuyerEligibilityForm showStep1={showSteps} />
              ) : (
                <Personaldetails
                  showPrevStep={showFirstStep}
                  formType="GetInTouchNew"
                />
              )}
            </FormProviderBuyer>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuyerCredit;
